import type { RiskType } from "@unbox/api";
import { InfoCircle } from "@untitledui/icons";
import { Tooltip, TooltipTrigger } from "@/components/base/tooltip/tooltip";
import { getRiskTypeIcon } from "../../utils";

type Evidence = { ts?: string; text: string; translation?: string };

type RiskBlockProps = {
  name: string;
  severity: "critical" | "high" | "medium" | "low";
  description?: string;
  evidenceType: RiskType;
  evidence: Evidence[];
  confirmedBy?: string;
  confirmedAt?: string;
};

export const RiskBlock = ({ name, description, evidenceType, evidence, confirmedBy, confirmedAt }: RiskBlockProps) => {
  return (
    <div className="border border-border-primary rounded-md p-3 bg-white mb-2 last:mb-0">
      <div className="mb-2 flex items-center gap-1.5">
        {getRiskTypeIcon(evidenceType, "w-4 h-4 text-secondary shrink-0")}
        <span className="text-sm font-medium text-primary truncate min-w-0">{name}</span>
        {description && (
          <Tooltip title={description} placement="top">
            <TooltipTrigger className="text-quaternary hover:text-fg-quaternary_hover shrink-0">
              <InfoCircle className="size-4" />
            </TooltipTrigger>
          </Tooltip>
        )}
      </div>
      {evidence.length > 0 && (
        <div className="text-[12.5px] text-primary leading-[1.5] mb-2">
          {evidence.map((ev) => (
            <p key={ev.text} className="m-0 mb-1 last:mb-0 text-quaternary text-sm">
              {ev.ts && (
                <button
                  type="button"
                  className="text-quaternary mr-1.5 text-sm underline decoration-dotted cursor-pointer bg-transparent border-0 p-0"
                  style={{ color: "#6941C6" }}
                >
                  [{ev.ts}]
                </button>
              )}
              {ev.text}
              {ev.translation && <em> ({ev.translation})</em>}
            </p>
          ))}
        </div>
      )}
      {confirmedBy && (
        <p className="text-[11.5px] text-tertiary m-0 leading-[1.4]">
          Confirmed by <strong className="font-medium text-secondary">{confirmedBy}</strong> · {confirmedAt}
        </p>
      )}
    </div>
  );
};
